import ApiService from "../../../services/api.service";

const ReportService = {

	getReportItems(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all`, data)
	},
	getReportItems51(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all-not-price`, data)
	},
	getReportItems_5(data) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses-all-with-reg-date`, data)
	},
	getReportItems1(depId, data) {
		return ApiService.post(`report/incomes/and/offs/in-term/${depId}`, data)
	},
	getReport31(depId, data) {
		return ApiService.post(`report/incomes/and/offs/in-term-with-deps/${depId}`, data)
	},
		getTotalSaleByPeriodAndDepartment(data) {
		return ApiService.post(`report/total-sale-by-period-and-department`, data)
	},
getReportItems2(data) {
		return ApiService.post(`report/remaining/of-items/in-term`, data)
	},
	getReportItemsNew2(data) {
		return ApiService.post(`/report/sales-quarter-report`, data)
	},
	getReportItemsNew3(data) {
		return ApiService.post(`/report/remaining-quarter-report`, data)
	},
	getReportItems12(data) {
		return ApiService.post(`/report/remaining/of-items/report-sale-by-currency`, data)
	},
	getReportItems3(data) {
		return ApiService.post(`report/item/transaction/in-term`, data)
	},
	getReportItems4(data) {
		return ApiService.post(`report/sale-items-with-group`, data)
	},
	getExcelItems(data) {
		return ApiService.post(`report/sale-items-with-excel`, data)
	},
	getExcelItems1(data) {
		return ApiService.post(`report/sale-items-with-excel-not-reg-date`, data)
	},
	getContragent(data) {
		return ApiService.post(`report/sale-items-with-group-with-contragent`, data)
	},
	getReportItems5(data) {
		return ApiService.post(`report/item-remaining-between-date`, data)
	},
	getReportItems6(data) {
		return ApiService.post(`report/write-off-items-with-group`, data)
	},
	getReportKpi(data) {
		return ApiService.post(`report/kpi-report`, data)
	},

	getDifferentDailyReport() {
		return ApiService.get(`/report/item-daily-profit`)
	},
	getDifferentMonthlyReport() {
		return ApiService.get(`/report/item-monthly-profit`)
	},
	getRemainingReport() {
		return ApiService.get(`/report/item-daily-balance`)
	},

	dailySaleSum() {
		return ApiService.get(`/report/item-daily-amount`)
	},
	dailySaleAvgSum() {
		return ApiService.get(`/report/item-avg-daily-amount `)
	},
	dailySaleCount() {
		return ApiService.get(`/report/item-number-of-daily-checks `)
	},
	getPendingDocs() {
		return ApiService.get(`/report/item-pending-document`)
	},
	getRemainingByGroup() {
		return ApiService.get(`/report/item-daily-balance-with-group`)
	},
	getTopEmployees(data) {
		return ApiService.post(`/report/sale-by-cashiers`, data)
	},

}

export default ReportService
